export default "__VITE_ASSET__bbc1b029__"